'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryContentAdvisoryEditor = require('./components/PrimaryContentAdvisoryEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryContentAdvisoryEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/primary-content-advisory-editor/index.js
// module id = 1035
// module chunks = 4